

let Stickyfill;
export const sticky = {
  async bind(el, binding, vnode) {
    if (!process.SERVER) {
      if (!Stickyfill) {
        await import('stickyfilljs').then(v => {
          Stickyfill = v;
        });
      }
      Stickyfill.addOne(el);
    }
  }
}
